import { ApolloError } from '@apollo/client';
import { Box } from '@bechtel/gds';
import { Jumper } from '@bechtel/sr-types';
import { FC, Suspense, lazy } from 'react';
import { ContentContainerStyled, ErrorBoundary, SuspenseLoader } from '~/components';

interface AdditionalInfoProps {
  data: Jumper;
  loading: boolean;
  error?: ApolloError | undefined;
}

const JumperFeedbackOverview = lazy(() => import('./overview'));

export const AdditionalInfo: FC<AdditionalInfoProps> = ({ data, loading, error }) => {
  return (
    <Box
      alignItems={{ sm: 'flex-start' }}
      flexDirection={{ sm: 'column' }}
      flexGrow={{ sm: 1 }}
      css={{ overflow: 'hidden' }}
    >
      <ContentContainerStyled>
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader />}>
            <JumperFeedbackOverview data={data} loading={loading} error={error} />
          </Suspense>
        </ErrorBoundary>
      </ContentContainerStyled>
    </Box>
  );
};
